import { Injectable } from '@angular/core';
import { initialize, LDClient, LDFlagChangeset } from 'launchdarkly-js-client-sdk';
import { fromEvent, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlags } from '../../types/feature-flags.type';
import { LDContextCommon } from 'launchdarkly-js-sdk-common';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private client: LDClient;

  async initialize(key: string, context: LDContextCommon): Promise<void> {
    this.client = initialize(key, {
      kind: 'user',
      ...context,
      key: context.key ?? `kodypay:${context['email']}`,
    });
    await this.client.waitForInitialization();

    this.client.track('Initialized');
  }

  flags(): FeatureFlags {
    return this.client.allFlags();
  }

  close(): Promise<void> {
    return this.client.close();
  }

  flagChanges$(): Observable<FeatureFlags> {
    return fromEvent<LDFlagChangeset>(this.client, 'change').pipe(
      // Only take the current (new) value
      map((flags) => Object.keys(flags).reduce((acc, key) => ({ ...acc, [key]: flags[key].current }), {}))
    );
  }
}
